module.exports = __webpack_public_path__ + "img/CB0020_cat.7ffd1385.png";